/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Pushed_TitleInputs */

const vi_einvoice_pushed_title = /** @type {(inputs: Einvoice_Pushed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản nháp trên MISA · Chưa phát hành`)
};

/**

* @param {Einvoice_Pushed_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_pushed_title = /** @type {((inputs?: Einvoice_Pushed_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Pushed_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_pushed_title(inputs)
});